import React from 'react';
import styled from 'styled-components';
import Box from '@digitools/honest-react/dist/lib/components/Box';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import Heading from '@digitools/honest-react/dist/lib/components/Heading';
import Collapse from '@digitools/honest-react/dist/lib/components/Collapse';
import { RedBulletList } from 'src/components/Formatting/StyledComponents';
import useEoiContext from '../hooks/useEoiContext';
// @ts-ignore
import useTranslate from '../../../hooks/useTranslate';
import QuickTipsText from '../i18n/QuickTipsText';
import { Icon } from '@digitools/honest-react';
const BoxContainer = styled('div') `
  @media (max-width: 1024px) {
    display: block;
  }
  display: flex;
  min-height: 8.125rem;
`;
const InlineColorHeaderBox = styled(Box) `
  @media (max-width: 1024px) {
    width: 100%;
    flex: 1;
  }
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  /* align-items: center; */
  padding: 1.5rem;
  min-width: 100px; 
  width: 8.125rem;
`;
const InlineContentBox = styled(Box) `
  @media (min-width: 1025px) {
    borderleft: none;
  }
  display: flex;
  flex: 1;
  margin-top: 0px;
`;
const QuickTipsBox = () => {
    const { t } = useTranslate();
    const { customerConfig } = useEoiContext();
    return (<BoxContainer data-testid='eoi-quick-tips' style={{ marginTop: '1.875rem' }} data-public={true}>
      <InlineColorHeaderBox type='color' theme={themes.rebrand} data-public={true}>
        <Icon name={'quick_tips'} color={'white'} size={'4.0rem'} data-public={true}/>
      </InlineColorHeaderBox>
      <InlineContentBox data-public={true}>
        <div style={{ display: 'block' }}>
          <Heading elemType='h3' theme={themes.rebrand}>{t(QuickTipsText.header)}</Heading>
          <Collapse type='alternate' title={t(QuickTipsText.collapseHeader)} theme={themes.rebrand}>
            <div style={{ marginLeft: '1rem' }}>
              <Heading elemType='h3' elemStyle='h4'>{t(QuickTipsText.applicantCoverageHeader)}</Heading>
              <RedBulletList>
                <li><span>{t(QuickTipsText.name)}</span></li>
                <li><span>{t(QuickTipsText.dob)}</span></li>
                <li><span>{t(QuickTipsText.social)}</span></li>
                <li><span>{t(QuickTipsText.height)}</span></li>
                <li><span>{t(QuickTipsText.weight)}</span></li>
                <li><span>{t(QuickTipsText.diagnosis)}</span></li>
              </RedBulletList>
              <Heading elemType='h3' elemStyle='h4'>{t(QuickTipsText.quickTipsHeader)}</Heading>
              <RedBulletList>
                <li><span>{t(QuickTipsText.answerAll)}</span></li>
                {customerConfig && customerConfig.saveForLater && <li><span>{t(QuickTipsText.saveForLater)}</span></li>}
                <li><span>{t(QuickTipsText.timeOut)}</span></li>
              </RedBulletList>
              <br />
            </div>
          </Collapse>
        </div>
      </InlineContentBox>
    </BoxContainer>);
};
export default QuickTipsBox;
